






























import { Component, Vue } from 'vue-property-decorator'
import { v4 as uuidv4 } from 'uuid'
interface ProductGroup {
  key: string;
  name: string;
}
@Component
export default class ManageProductGroupsModal extends Vue {
  closeModal () {
    this.$bvModal.hide('add-new-product-modal')
  }

  get productGroups () {
    return this.$store.getters.getProductGroups
  }

  async mounted () {
    await this.$store.dispatch('loadProductGroups')
  }

  items: ProductGroup[] = this.productGroups;
  fields = [
    { key: 'name', label: 'Name' },
    { key: 'actions', label: 'Actions' }
  ];

  showModalFlag = false;
  modalId = 'item-modal';
  form: Partial<ProductGroup> = { key: '', name: '' };
  editMode = false;

  async loadGroups () {
    await this.$store.dispatch('loadProductGroups')
    this.items = this.$store.getters.getProductGroups
  }

  showModal (mode: 'create' | 'edit', item: ProductGroup | null = null) {
    this.editMode = mode === 'edit'
    if (this.editMode && item) {
      this.form = { ...item }
    } else {
      this.form = { key: '', name: '' }
    }
    this.showModalFlag = true
  }

  handleSubmit () {
    if (this.editMode) {
      this.updateItem()
    } else {
      this.createItem()
    }
    this.showModalFlag = false
  }

  async createItem () {
    const newItem: ProductGroup = {
      key: uuidv4(),
      name: this.form.name!
    }
    this.items.push(newItem)
    await this.$store.dispatch('addProductGroup', newItem)
  }

  editItem (item: ProductGroup) {
    this.showModal('edit', item)
  }

  async updateItem () {
    const index = this.items.findIndex(item => item.key === this.form.key)
    if (index !== -1) {
      const updatedItem: ProductGroup = {
        ...this.form
      } as ProductGroup
      this.$set(this.items, index, updatedItem)
      await this.$store.dispatch('saveProductGroup', updatedItem)
    }
  }

  async deleteItem (key: string) {
    this.$bvModal
      .msgBoxConfirm('Are you sure you wish to delete this franchise?', {
        size: 'sm',
        buttonSize: 'sm',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(async () => {
        this.items = this.items.filter(item => item.key !== key)
        await this.$store.dispatch('deleteProductGroup', key)
      })
  }
}
